export const VARIATIONS = {
  PRIMARY: "PRIMARY",
};

export const SIZES = {
  NORMAL: "NORMAL",
};
